import { VariableType } from 'json-to-graphql-query';

import { Resource } from './resource';

/**
 * Resource statystyk
 *
 * @export
 * @class StatisticsResource
 * @extends {Resource}
 */
export class StatisticsResource extends Resource {
  /**
   * Pobiera statystyki procedury
   *
   * @param {*} variables
   * @returns {Promise<any>}
   * @memberof StatisticsResource
   */
  public procedureStatistics(variables: any): Promise<any> {
    const query = this.prepareOptions({
      query: {
        __variables: { procedureId: 'Int!', filters: 'MongoDBFilters!' },
        procedureStatistics: {
          __args: { procedureId: new VariableType('procedureId'), filters: new VariableType('filters') }
        }
      }
    });
    return this.query({ query, variables }, 'procedureStatistics');
  }

  /**
   * Statystyki decyzji na podstawie załączników
   *
   * @param {*} variables
   * @returns {Promise<any>}
   * @memberof StatisticsResource
   */
  public generatedAttachmentsStatistics(variables: any): Promise<any> {
    const query = this.prepareOptions({
      query: {
        __variables: { procedureId: 'Int!', filters: 'MongoDBFilters' },
        generatedAttachmentsStatistics: {
          __args: { procedureId: new VariableType('procedureId'), filters: new VariableType('filters') },
          list: {
            attachmentId: true,
            created: true,
            modified: true,
            name: true,
            entityType: true,
            entityId: true,
            type: true,
            mediaId: true,
            view: true,
            document: true,
            systemNumber: true,
            parsedSystemNumber: true
          }
        }
      }
    });
    return this.query({ query, variables }, 'generatedAttachmentsStatistics');
  }
}

export const statisticsResource = new StatisticsResource();
